import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const DeletePricingBookmarksDocument = gql`
  mutation DeletePricingBookmarks(
    $entries: [DeletePricingBookmarkEntryInput!]!
  ) {
    deletePricingBookmarks(entries: $entries) {
      deleted_count
    }
  }
`;
export type DeletePricingBookmarksMutationFn = Apollo.MutationFunction<
  Types.DeletePricingBookmarksMutation,
  Types.DeletePricingBookmarksMutationVariables
>;
export function useDeletePricingBookmarksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeletePricingBookmarksMutation,
    Types.DeletePricingBookmarksMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeletePricingBookmarksMutation,
    Types.DeletePricingBookmarksMutationVariables
  >(DeletePricingBookmarksDocument, options);
}
export type DeletePricingBookmarksMutationHookResult = ReturnType<
  typeof useDeletePricingBookmarksMutation
>;
export type DeletePricingBookmarksMutationResult =
  Apollo.MutationResult<Types.DeletePricingBookmarksMutation>;
export type DeletePricingBookmarksMutationOptions = Apollo.BaseMutationOptions<
  Types.DeletePricingBookmarksMutation,
  Types.DeletePricingBookmarksMutationVariables
>;
